import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/fonts'
import './index.css'
import { App } from './app/App'
import { applyStoredTheme } from './app/theme'
import { initDeviceIdentity } from './offline/device'

applyStoredTheme()
// Every API request carries this browser install's device uid (X-Device-Uid).
void initDeviceIdentity().catch((e) => console.error('Device identity unavailable', e))

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
